import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NotFoundComponent } from "./core/components/not-found/not-found.component";
const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./modules/main/main.module").then((m) => m.MainModule),
  },
  {path: "**" , component : NotFoundComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
